import AgencyHelper, { AgencyConstants } from "features/Agency/agencyHelper";
import AppResource from "general/constants/AppResource";
import ToastHelper from "general/helpers/ToastHelper";
import DialogReconciliationFeedback from "./SaleReconciliationReport/components/DialogReconciliationFeedback";
import { AppCustomDialogHelper } from "general/components/AppDialogCustom";
import AgencySaleDialogView from "features/Agency/components/AgencySaleDialogView";
import AppColors from "general/constants/AppColors";
import UIHelper from "general/helpers/UIHelper";
import Utils from "general/utils/Utils";
import DialogSignReconciliationView from "./SaleReconciliationReport/components/DialogSignReconciliationView";

const ReconciliationReportHelper = {

    // lay ten loai doi soat
    reconciliationTypeOptions: [
        { value: AgencyConstants.ContractType.DIGITAL, name: 'Đối soát điện tử' },
        { value: AgencyConstants.ContractType.PAPER, name: 'Đối soát giấy' },
    ],
    // ---- methods ----

    // ten loai doi soat
    getReconciliationTypeName: (type) => {
        switch (type) {
            case AgencyConstants.ContractType.DIGITAL:
                return 'Đối soát điện tử';
            case AgencyConstants.ContractType.PAPER:
                return 'Đối soát giấy';
            default:
                return '';
        }
    },

    // ten trang thai doi soat
    getReconciliationStatusName: (status, agencyType) => {
        switch (status) {
            case AgencyConstants.AgencyReconciliationStatus.CREATED:
                return 'Chờ phê duyệt';
            case AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED:
                return 'Đã ký bởi NĐH';
            case AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED:
                return agencyType === 'SALE' ? 'Đã ký bởi đại lý' : 'Đã ký bởi NĐT';
            case AgencyConstants.AgencyReconciliationStatus.COMPLETED:
                return 'Hoàn thành';
            default:
                return '';
        }
    },
    // mau sac trang thai doi soat
    getReconciliationStatusColor: (status) => {
        switch (status) {
            case AgencyConstants.AgencyReconciliationStatus.CREATED:
                return 'warning';
            case AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED:
                return 'success';
            case AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED:
                return 'primary';
            case AgencyConstants.AgencyReconciliationStatus.COMPLETED:
                return 'success';
            default:
                return '';
        }
    },

    // format ngay
    formatSaleByDate: (saleByDate, year, month) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        const result = Array.from({ length: daysInMonth }, (_, index) => {
            const day = index + 1;
            const formattedDate = `${day.toString().padStart(2, '0')}`;
            return {
                date: formattedDate,
                count: 0,
                amount: 0,
            };
        });

        saleByDate?.forEach((sale) => {
            const saleDate = new Date(sale.date);
            if (saleDate.getFullYear() === year && saleDate.getMonth() === month - 1) {
                const saleDay = saleDate.getDate();
                const index = saleDay - 1;
                if (index >= 0 && index < result.length) {
                    result[index].count = sale.count;
                    result[index].amount = sale.amount;
                }
            }
        });

        return result;
    },

    formatReferralByDate: (referralsByDate, year, month) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        const result = Array.from({ length: daysInMonth }, (_, index) => {
            const day = index + 1;
            const formattedDate = `${day.toString().padStart(1)}`;
            return {
                date: formattedDate,
                count: 0,
                commission: 0,
            };
        });

        referralsByDate?.forEach((referral) => {
            const referralDate = new Date(referral.date);
            if (referralDate.getFullYear() === year && referralDate.getMonth() === month - 1) {
                const referralDay = referralDate.getDate();
                const index = referralDay - 1;
                if (index >= 0 && index < result.length) {
                    result[index].count = referral.count;
                    result[index].commission = referral.commission;
                }
            }
        });

        return result;
    },

    signAgencyReconciliation: async (reconciliationId, status) => {
        const res = await AgencyHelper.API.requestUpdateReconciliation(reconciliationId, { status: status });
        if (res === 'success') {
            ToastHelper.showSuccess('Ký đối soát thành công');
        } else {
            ToastHelper.showError(res);
        }
    },

    // filter trang thai doi soat
    filterStatusOptions: (agencyRole) => {
        return [
            { name: 'Tất cả', value: '' },
            {
                name: 'Chờ phê duyệt',
                value: AgencyConstants.AgencyReconciliationStatus.CREATED,
            },
            {
                name: 'Đã ký bởi NĐH',
                value: AgencyConstants.AgencyReconciliationStatus.ADMIN_SIGNED,
            },
            {
                name: `Đã ký bởi ${agencyRole === 'SALE' ? 'đại lý' : 'NĐT'}`,
                value: AgencyConstants.AgencyReconciliationStatus.AGENCY_SIGNED,
            },
            {
                name: 'Hoàn thành',
                value: AgencyConstants.AgencyReconciliationStatus.COMPLETED,
            },
        ];
    },

    // tai file excel doi soat
    handleDownloadExcelFile: async (file) => {
        if (!file) {
            ToastHelper.showError('Không tìm thấy file Excel để tải');
            return;
        }

        try {
            const response = await fetch(file);
            if (!response.ok) {
                throw new Error('Lỗi khi tải file');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `doi_soat_${row?.month || 'unknown'}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            ToastHelper.showSuccess('Tải file Excel thành công');
        } catch (error) {
            console.error('Error downloading file:', error);
            ToastHelper.showError('Có lỗi xảy ra khi tải file Excel');
        }
    },

    // hien dialog phan hoi doi soat
    showDialogReconciliationFeedback: (reconciliation, adminRole, onDone) => {
        AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogFeedback} />}
                title={adminRole ? "Xem phản hồi" : "Gửi phản hồi"}
                contentEl={
                    adminRole ?
                        <>
                            Xem phản hồi từ đối tác
                        </>
                        : <>
                            Vui lòng nhập lý do gửi phản hồi cho nhà điều hành.
                        </>
                }
                bodyEl={
                    <DialogReconciliationFeedback
                        reconciliation={reconciliation}
                        adminRole={adminRole}
                        onCancel={() => {
                            AppCustomDialogHelper.hide();
                        }}
                        onDone={() => {
                            AppCustomDialogHelper.hide();
                            if (onDone) {
                                onDone();
                            }
                        }}
                    />
                }
                removeFooter={true}
            />,
            'md',
            false,
            true
        );
    },

    handleAgencySignReconciliation: (row, onDone) => {
        AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
                title="Ký đối soát"
                contentEl={
                    <>
                        Bạn muốn ký đối soát:{' '}
                        <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                            {Utils.formatDateTimeToString(row?.month, 'MM/YYYY')}
                        </span>
                        ?
                    </>
                }
                inputLabel={['Số thỏa thuận (Agreement UUID)', 'Mật khẩu chữ ký số']}
                showInput={true}
                additionalInfo={
                    <div
                        className="d-flex gap-3 p-3 align-items-center"
                        style={{
                            border: `1px dashed ${AppColors.danger}`,
                            backgroundColor: '#FFF6F6',
                        }}
                    >
                        <div className="w-32px h-32px rounded-circle bg-danger-o-20 d-flex align-items-center justify-content-center">
                            <i className="fas fa-signature" style={{ color: AppColors.danger }} />
                        </div>
                    </div>
                }
                onCancel={() => {
                    AppCustomDialogHelper.hide();
                }}
                onConfirm={async (values) => {
                    const [hsmAgreementUUID, hsmPassword] = values;
                    AppCustomDialogHelper.hide();
                    let result = true;
                    result = await AgencyHelper.API.requestAgencySignReconciliation({
                        reconciliationId: row?.reconciliationId,
                        hsmPasscode: hsmPassword
                    });
                    if (result && _.isBoolean(result)) {
                        ToastHelper.showSuccess('Ký đối soát thành công');
                        if (onDone) {
                            onDone();
                        }
                    } else {
                        ToastHelper.showError(result || 'Ký đối soát thất bại');
                    }
                }}
            />,
            'md',
            false,
            true
        );
    },

    handleAdminSignReconciliation: (row, onDone) => {
        AppCustomDialogHelper.show(
            '',
            <AgencySaleDialogView
                iconEl={<img src={AppResource.images.dialogIcons.dialogSignContract} />}
                title="Duyệt & ký đối soát"
                contentEl={
                    <>
                        Bạn có chắc muốn duyệt và ký đối soát{' '}
                        <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                            {Utils.formatDateTimeToString(row?.month, 'MM/YYYY')}
                        </span>
                        {' '} của {' '}
                        <span>
                            {AgencyHelper.Utils.getShortAgencyRoleName(row?.agency?.primaryRole).toLowerCase()}{' '}
                        </span>
                        <span style={UIHelper.buildFontStyle('700', '14px', AppColors.gray[600])}>
                            {row?.agency?.name}
                        </span>
                        {' '} không?
                    </>
                }
                bodyEl={
                    <DialogSignReconciliationView
                        item={row}
                        onCancel={() => {
                            AppCustomDialogHelper.hide();
                        }}
                        onDone={() => {
                            AppCustomDialogHelper.hide();
                            if (onDone) {
                                onDone();
                            }
                        }}
                    />
                }
                removeFooter={true}
            />,
            'md',
            false,
            true
        );
    },
}

export default ReconciliationReportHelper;